import { Button, Form, Modal, Input } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import useNotify from '../../../../context/Notification/useNotify';
import RiskRegisterService from '../../../../services/RiskRegister.service';

const ModalRevise = ({ open, handelClose, getDetailInfo, status }) => {
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    let { riskId } = useParams();
    const notify = useNotify();

    const onFinish = async (values) => {
        setLoading(true);
        const payload = {
            riskRegisterId: riskId,
            status,
            lastReviewDate: null,
            nextReviewDue: null,
            ...values,
        };
        try {
            const { data } = await RiskRegisterService.changeStatus(payload);
            if (data?.resultCode === 1) {
                setLoading(false);
                handelClose();
                getDetailInfo();
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to submitted'),
                });
            }
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
            setLoading(false);
            console.log(error);
        }
    };

    return (
        <Modal
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="pt-8 pb-8">
                <div className="text-2xl font-semibold pb-12 text-center"></div>

                <div
                    className="text-4xl mb-6 "
                    style={{ color: '#A8A8AF', textAlign: 'center' }}
                >
                    <svg
                        width={220}
                        height={120}
                        viewBox="0 0 220 120"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clipPath="url(#clip0_6897_332829)">
                            <path
                                d="M116.659 92.462C142.253 92.462 163 71.7637 163 46.231C163 20.6983 142.253 0 116.659 0C91.0659 0 70.3184 20.6983 70.3184 46.231C70.3184 71.7637 91.0659 92.462 116.659 92.462Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M146.943 20.6742H62.0531C61.8711 20.6704 61.7267 20.52 61.7305 20.3384C61.7343 20.1623 61.8765 20.0204 62.0531 20.0166H146.943C147.125 20.0205 147.27 20.1708 147.266 20.3525C147.262 20.5286 147.12 20.6705 146.943 20.6742Z"
                                fill="#CACACA"
                            />
                            <path
                                d="M118.012 31.7559H94.5451C92.7824 31.7559 91.3535 33.1814 91.3535 34.9398V34.9398C91.3535 36.6983 92.7824 38.1238 94.5451 38.1238H118.012C119.775 38.1238 121.204 36.6983 121.204 34.9398C121.204 33.1814 119.775 31.7559 118.012 31.7559Z"
                                fill="white"
                            />
                            <path
                                d="M79.3849 44.4922H133.172C134.934 44.4922 136.363 45.9177 136.363 47.6762C136.363 49.4346 134.934 50.8601 133.172 50.8601H79.3849C77.6223 50.8601 76.1934 49.4346 76.1934 47.6762C76.1934 45.9177 77.6223 44.4922 79.3849 44.4922Z"
                                fill="white"
                            />
                            <path
                                d="M79.3849 57.2275H133.172C134.934 57.2275 136.363 58.6531 136.363 60.4115C136.363 62.17 134.934 63.5955 133.172 63.5955H79.3849C77.6223 63.5955 76.1934 62.17 76.1934 60.4115C76.1934 58.6531 77.6223 57.2275 79.3849 57.2275Z"
                                fill="white"
                            />
                            <path
                                d="M128.086 58.7893C127.159 58.7893 126.252 58.5155 125.481 58.0025C124.71 57.4895 124.108 56.7604 123.753 55.9073C123.399 55.0543 123.306 54.1156 123.487 53.2099C123.668 52.3043 124.114 51.4725 124.77 50.8195C125.426 50.1666 126.262 49.722 127.171 49.5419C128.081 49.3617 129.024 49.4542 129.881 49.8075C130.738 50.1609 131.471 50.7593 131.986 51.527C132.501 52.2948 132.776 53.1974 132.776 54.1207C132.775 55.3585 132.28 56.5451 131.401 57.4204C130.522 58.2956 129.33 58.7879 128.086 58.7893ZM128.086 49.9436C127.256 49.9436 126.445 50.1886 125.755 50.6476C125.065 51.1065 124.527 51.7589 124.21 52.5222C123.892 53.2855 123.809 54.1254 123.971 54.9357C124.133 55.746 124.532 56.4903 125.119 57.0744C125.706 57.6586 126.454 58.0565 127.268 58.2176C128.082 58.3788 128.925 58.2961 129.692 57.9799C130.459 57.6638 131.114 57.1284 131.575 56.4414C132.037 55.7545 132.283 54.9469 132.283 54.1207C132.283 53.5722 132.174 53.029 131.963 52.5222C131.752 52.0154 131.443 51.5549 131.054 51.167C130.664 50.7792 130.201 50.4715 129.692 50.2615C129.183 50.0516 128.637 49.9436 128.086 49.9436Z"
                                fill="#DFDFDF"
                            />
                            <path
                                d="M127.23 56.3687C127.186 56.3687 127.143 56.3604 127.102 56.3442C127.062 56.328 127.025 56.3043 126.994 56.2744L125.926 55.2445C125.895 55.2147 125.87 55.1792 125.854 55.1402C125.837 55.1012 125.828 55.0594 125.828 55.0171C125.828 54.9749 125.837 54.9331 125.854 54.8941C125.87 54.855 125.895 54.8196 125.926 54.7898L125.981 54.7364C126.044 54.6762 126.129 54.6424 126.217 54.6424C126.306 54.6424 126.39 54.6762 126.453 54.7364L127.007 55.2702C127.027 55.29 127.052 55.3053 127.08 55.315C127.107 55.3246 127.136 55.3283 127.166 55.3259C127.195 55.3235 127.223 55.315 127.248 55.301C127.273 55.287 127.295 55.2678 127.312 55.2448L129.674 52.0095C129.725 51.9398 129.802 51.8924 129.889 51.8778C129.977 51.8632 130.066 51.8825 130.139 51.9316L130.203 51.9752C130.239 51.9995 130.269 52.0304 130.293 52.066C130.316 52.1017 130.332 52.1415 130.339 52.1831C130.347 52.2247 130.346 52.2673 130.336 52.3085C130.327 52.3498 130.309 52.3887 130.284 52.4233L127.503 56.2322C127.475 56.2706 127.439 56.3026 127.396 56.326C127.354 56.3493 127.307 56.3635 127.259 56.3675C127.249 56.3684 127.239 56.3687 127.23 56.3687Z"
                                fill="#ABABAB"
                            />
                            <path
                                d="M72.7197 119.72L72.5931 119.707C68.2982 119.265 64.4157 116.961 61.9769 113.407C61.3089 112.416 60.7686 111.346 60.3687 110.221L60.3302 110.113L60.444 110.104C61.8027 109.995 63.1985 109.765 63.8185 109.656L59.8203 108.304L59.7956 108.186C59.5585 107.075 60.0229 105.932 60.9684 105.299C61.9165 104.635 63.1737 104.614 64.1437 105.245C64.579 105.522 65.0343 105.797 65.4746 106.063C66.9877 106.976 68.5522 107.92 69.7253 109.212C71.504 111.21 72.2837 113.902 71.8471 116.539L72.7197 119.72Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M87.2525 117.736L89.2229 117.736L90.1605 110.153L87.252 110.153L87.2525 117.736Z"
                                fill="#A0616A"
                            />
                            <path
                                d="M87.1837 119.787L93.2435 119.787V119.71C93.2434 118.411 92.1874 117.357 90.8848 117.357H90.8847L89.7778 116.52L87.7126 117.357L87.1836 117.357L87.1837 119.787Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M71.4609 112.291L73.0371 113.471L78.3486 107.967L76.0221 106.226L71.4609 112.291Z"
                                fill="#A0616A"
                            />
                            <path
                                d="M70.1719 113.89L75.0193 117.518L75.0652 117.456C75.8469 116.417 75.6359 114.942 74.594 114.162L74.5939 114.162L74.2125 112.829L72.0564 112.263L71.6333 111.946L70.1719 113.89H70.1719Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M78.0119 82.1513C78.0119 82.1513 78.1207 85.1115 78.2579 87.4856C78.2804 87.8749 77.3661 88.2979 77.3897 88.7214C77.4055 89.0024 77.5773 89.2756 77.5933 89.5686C77.6101 89.8779 77.3729 90.1516 77.3897 90.4714C77.4063 90.7838 77.677 91.1422 77.6933 91.462C77.869 94.9037 78.506 99.0239 77.8681 100.176C77.5538 100.743 73.5469 108.607 73.5469 108.607C73.5469 108.607 75.7794 111.948 76.4173 110.835C77.2597 109.364 83.7527 102.482 83.7527 101.168C83.7527 99.8559 85.2548 90.0196 85.2548 90.0196L86.3022 95.8406L86.7825 96.9939L86.6316 97.671L86.942 98.5848L86.9587 99.4891L87.2609 101.168C87.2609 101.168 86.352 114.252 86.8638 114.616C87.3773 114.982 89.8634 115.639 90.1568 114.982C90.4486 114.325 92.3481 101.327 92.3481 101.327C92.3481 101.327 92.6543 95.3713 92.986 89.835C93.0051 89.5137 93.2315 89.1255 93.2491 88.8089C93.2698 88.4414 93.1263 87.9642 93.1454 87.6078C93.1662 87.199 93.3479 86.911 93.3655 86.5196C93.501 83.4954 92.7401 79.8127 92.4978 79.45C91.7658 78.3554 91.1072 77.4805 91.1072 77.4805C91.1072 77.4805 81.2487 74.249 78.6143 77.5326L78.0119 82.1513L78.0119 82.1513Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M87.8444 51.7104L83.9363 50.9307L82.1125 53.3999C78.7094 56.7381 78.6582 59.6844 79.2657 64.4069V71.0349L78.826 75.4782C78.826 75.4782 77.2694 78.7262 78.8748 79.4825C80.4803 80.2387 91.0254 80.1742 92.0322 79.8724C93.039 79.5705 92.1664 79.1998 91.902 77.793C91.4053 75.1503 91.7375 76.425 91.7717 75.5836C92.2617 63.5137 91.1203 58.5586 91.0044 57.2562L89.0169 53.6599L87.8444 51.7104Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M108.442 61.442C108.034 62.212 107.078 62.5067 106.307 62.1004C106.224 62.057 106.146 62.0066 106.073 61.9495L97.6328 67.2957L97.6571 64.3849L105.856 59.6384C106.44 58.9851 107.444 58.9279 108.099 59.5105C108.647 59.998 108.788 60.7965 108.442 61.442Z"
                                fill="#A0616A"
                            />
                            <path
                                d="M84.7576 55.081L83.7967 54.9794C82.9089 54.8875 82.0378 55.2669 81.5017 55.9788C81.2963 56.2488 81.1489 56.5581 81.0684 56.8873L81.0678 56.89C80.8268 57.8811 81.2048 58.9198 82.0271 59.5257L85.3459 61.9667C87.6748 65.1062 92.0519 67.1891 97.1862 68.8813L105.167 63.9366L102.344 60.526L96.8701 63.4527L88.7334 57.169L88.7287 57.1652L85.6318 55.1747L84.7576 55.081L84.7576 55.081Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M86.5223 49.7954C89.0393 49.7954 91.0797 47.7598 91.0797 45.2488C91.0797 42.7377 89.0393 40.7021 86.5223 40.7021C84.0053 40.7021 81.9648 42.7377 81.9648 45.2488C81.9648 47.7598 84.0053 49.7954 86.5223 49.7954Z"
                                fill="#A0616A"
                            />
                            <path
                                d="M86.6275 49.7969C86.5908 49.7981 86.5539 49.7989 86.5172 49.7999C86.5014 49.8406 86.4844 49.881 86.4648 49.9207L86.6275 49.7969V49.7969Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M87.8789 45.375C87.8861 45.4198 87.897 45.4639 87.9116 45.5069C87.9056 45.4619 87.8946 45.4176 87.8789 45.375Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M91.1384 40.897C90.9508 41.4781 90.7834 40.741 90.1663 40.8736C89.424 41.0331 88.5601 40.9783 87.9522 40.5243C87.0464 39.8613 85.8726 39.6828 84.8099 40.0465C83.7697 40.4137 82.027 40.6725 81.7559 41.7396C81.6617 42.1105 81.6243 42.513 81.3959 42.8204C81.1963 43.0892 80.8811 43.2424 80.6176 43.4493C79.7278 44.1477 80.4079 46.1321 80.829 47.1806C81.2502 48.2291 82.2163 48.9929 83.2784 49.3842C84.3061 49.7627 85.4215 49.8295 86.5178 49.7997C86.7084 49.3064 86.6261 48.7365 86.4687 48.2251C86.2984 47.6714 86.0462 47.137 85.975 46.5622C85.9039 45.9874 86.0601 45.3345 86.5433 45.0133C86.9873 44.7181 87.7099 44.8979 87.8789 45.3752C87.7803 44.7785 88.3862 44.2011 89.011 44.0996C89.6817 43.9905 90.3525 44.2321 91.0213 44.3524C91.6901 44.4726 91.4527 41.6635 91.1384 40.897Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M116.628 52.7699C117.053 47.6487 113.236 43.1536 108.103 42.7297C102.969 42.3059 98.4636 46.1139 98.0388 51.2351C97.6139 56.3563 101.431 60.8514 106.564 61.2752C111.698 61.6991 116.204 57.8911 116.628 52.7699Z"
                                fill="#F0536F"
                            />
                            <path
                                d="M109.782 48.1258L107.332 50.5699L104.882 48.1258C104.485 47.7302 103.842 47.7302 103.446 48.1258C103.049 48.5215 103.049 49.1629 103.446 49.5586L105.896 52.0027L103.446 54.4468C103.05 54.8428 103.05 55.4843 103.447 55.8796C103.844 56.2743 104.486 56.2743 104.882 55.8796L107.332 53.4354L109.782 55.8796C110.179 56.2748 110.822 56.2742 111.218 55.8782C111.614 55.4827 111.614 54.8423 111.218 54.4468L108.768 52.0027L111.218 49.5586C111.615 49.1629 111.615 48.5215 111.218 48.1258C110.821 47.7302 110.178 47.7302 109.782 48.1258Z"
                                fill="white"
                            />
                            <path
                                d="M103.658 44.1822C103.933 45.0085 103.484 45.9006 102.656 46.1749C102.568 46.2041 102.477 46.2255 102.385 46.2388L100.409 56.016L98.3203 53.9833L100.563 44.7949C100.495 43.9223 101.149 43.1598 102.023 43.0917C102.755 43.0348 103.431 43.4857 103.658 44.1822Z"
                                fill="#A0616A"
                            />
                            <path
                                d="M82.6594 56.8283L81.9207 57.4497C81.2396 58.0252 80.9109 58.9149 81.0548 59.7938C81.1079 60.1285 81.2295 60.4488 81.412 60.7347L81.4135 60.7369C81.9635 61.5966 82.9765 62.0435 83.9841 61.8711L88.0472 61.1718C91.9305 61.6687 96.4674 59.9597 101.246 57.435L103.194 48.2666L98.7731 47.9375L97.1004 53.9043L86.9222 55.4117L86.9162 55.4124L83.3324 56.2638L82.6594 56.8283L82.6594 56.8283Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M105.796 119.944L56.2165 120C56.0966 120 55.9996 119.902 56 119.783C56.0004 119.664 56.0971 119.567 56.2165 119.567L105.796 119.511C105.916 119.511 106.013 119.608 106.012 119.728C106.012 119.847 105.915 119.944 105.796 119.944Z"
                                fill="#CACACA"
                            />
                            <path
                                d="M66.3593 16.5093C67.2114 16.5093 67.9021 15.8048 67.9021 14.9358C67.9021 14.0668 67.2114 13.3623 66.3593 13.3623C65.5072 13.3623 64.8164 14.0668 64.8164 14.9358C64.8164 15.8048 65.5072 16.5093 66.3593 16.5093Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M71.6893 16.5093C72.5415 16.5093 73.2322 15.8048 73.2322 14.9358C73.2322 14.0668 72.5415 13.3623 71.6893 13.3623C70.8372 13.3623 70.1465 14.0668 70.1465 14.9358C70.1465 15.8048 70.8372 16.5093 71.6893 16.5093Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M77.0194 16.5093C77.8715 16.5093 78.5623 15.8048 78.5623 14.9358C78.5623 14.0668 77.8715 13.3623 77.0194 13.3623C76.1673 13.3623 75.4766 14.0668 75.4766 14.9358C75.4766 15.8048 76.1673 16.5093 77.0194 16.5093Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M83.0966 16.1796C83.0492 16.1796 83.0019 16.1613 82.9661 16.1248L81.9251 15.0632C81.8557 14.9924 81.8557 14.8794 81.9251 14.8086L82.9661 13.747C83.0368 13.6752 83.1524 13.6741 83.2241 13.7442C83.2962 13.8145 83.2974 13.9298 83.227 14.0016L82.3107 14.9359L83.227 15.8703C83.2974 15.9421 83.2962 16.0574 83.2241 16.1277C83.1887 16.1623 83.1426 16.1796 83.0966 16.1796Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M84.8465 16.1797C84.8005 16.1797 84.7544 16.1625 84.7189 16.1278C84.6469 16.0575 84.6456 15.9423 84.7161 15.8704L85.6322 14.936L84.7161 14.0017C84.6456 13.9299 84.6469 13.8146 84.7189 13.7443C84.7908 13.6739 84.9065 13.6753 84.9769 13.7472L86.0179 14.8088C86.0873 14.8795 86.0873 14.9926 86.0179 15.0633L84.9769 16.125C84.9412 16.1614 84.8939 16.1797 84.8465 16.1797Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M139.308 13.5449H137.372C137.151 13.5449 136.973 13.7233 136.973 13.9435V15.8765C136.973 16.0967 137.151 16.2751 137.372 16.2751H139.308C139.529 16.2751 139.709 16.0967 139.709 15.8765V13.9435C139.709 13.7233 139.529 13.5449 139.308 13.5449Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M134.564 13.5449H132.628C132.407 13.5449 132.229 13.7233 132.229 13.9435V15.8765C132.229 16.0967 132.407 16.2751 132.628 16.2751H134.564C134.785 16.2751 134.965 16.0967 134.965 15.8765V13.9435C134.965 13.7233 134.785 13.5449 134.564 13.5449Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M143.777 13.6357H141.841C141.62 13.6357 141.441 13.8141 141.441 14.0343V15.9673C141.441 16.1876 141.62 16.3659 141.841 16.3659H143.777C143.997 16.3659 144.178 16.1876 144.178 15.9673V14.0343C144.178 13.8141 143.997 13.6357 143.777 13.6357Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M114.601 14.3711H99.1278C98.8577 14.3711 98.6406 14.5895 98.6406 14.8571C98.6406 15.1246 98.8577 15.343 99.1278 15.343H114.601C114.869 15.343 115.088 15.1246 115.088 14.8571C115.088 14.5895 114.869 14.3711 114.601 14.3711Z"
                                fill="#3F3D56"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_6897_332829">
                                <rect width={220} height={120} fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div className="text-2xl font-semibold pb-2 text-center ">
                    {t('RR.ReturnToReviseTask')}
                </div>
                <div className=" pb-2 text-center text-[#65707A]">
                    {t('RR.DoYouWantToReturnToReviseTask')}
                </div>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="reason"
                        rules={[
                            {
                                required: true,
                                message: t('RR.ReasonIsRequired'),
                            },
                        ]}
                        label={t('Reason')}
                    >
                        <Input.TextArea
                            rows={4}
                            placeholder={t('RR.PleaseMessageNotifyDataOwner')}
                            showCount
                            maxLength={250}
                        />
                    </Form.Item>

                    <div className="flex justify-center items-center space-x-4 pt-12">
                        <Button
                            className="w-36"
                            type="primary"
                            onClick={handelClose}
                            size="large"
                            ghost
                            htmlType="reset"
                        >
                            {t('common.Cancel')}
                        </Button>

                        <Button
                            className="w-36"
                            loading={loading}
                            size="large"
                            type="primary"
                            htmlType="submit"
                        >
                            {t('common.Confirm')}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
};

export default ModalRevise;
